import {hasBalansResponse} from './balansTaskResponse';

export const attendanceLabels = {
  planned: 'Запланировано',
  attended: 'Вышел',
  absent: 'Не вышел',
};

export function attendanceBlockReason(entry, status) {
  if (!entry.can_edit) return 'Заявка закрыта для редактирования или нет прав на её изменение.';
  if (status === 'attended' && entry.attendance_status !== 'attended' &&
      Number(entry.employment_type) === 1 && !hasBalansResponse(entry)) {
    return 'Нельзя отметить «Вышел»: исполнитель СМЗ должен откликнуться на это задание в Баланс Про.';
  }
  return '';
}

export function responseIndicator(entry) {
  if (entry.attendance_status !== 'planned' || Number(entry.employment_type) !== 1) return null;
  if (hasBalansResponse(entry)) return {accepted: true, text: 'Исполнитель откликнулся в Баланс Про'};
  const reason = {
    refused: 'Исполнитель отказался от задания в Баланс Про',
    reserve: 'Исполнитель в резерве в Баланс Про',
    rejected: 'Исполнитель снят с задания в Баланс Про',
    not_sent: 'Задание ещё не отправлено исполнителю в Баланс Про',
  }[entry.balans_pro_response_status] || 'Исполнитель не откликнулся в Баланс Про';
  return {accepted: false, text: `${reason}. Переход в «Вышел» недоступен.`};
}

export function attendanceRows(entries) {
  const rows = new Map();
  entries.forEach(entry => {
    if (!rows.has(entry.worker_id)) {
      rows.set(entry.worker_id, {id: entry.worker_id, name: entry.worker_name, cells: {}, rates: [], days: new Set(), units: 0, amount: 0});
    }
    const row = rows.get(entry.worker_id);
    if (!row.cells[entry.date]) row.cells[entry.date] = [];
    row.cells[entry.date].push(entry);
    if (!row.rates.includes(entry.price)) row.rates.push(entry.price);
    if (entry.attendance_status === 'attended') {
      row.days.add(entry.date);
      row.units += Number(entry.total_units) || 0;
      row.amount += Number(entry.gross_price == null ? entry.total_price : entry.gross_price) || 0;
    }
  });
  return Array.from(rows.values()).sort((a, b) => a.name.localeCompare(b.name, 'ru') || a.id - b.id);
}



// WEBPACK FOOTER //
// ./src/utilites/taskAttendance.js